var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404V1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4891",
    viewBox: "0 0 127 127",
    height: 480,
    width: 480,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4885"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-169.99998)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.85193944
    },
    id: "g4841",
    transform: "matrix(1.1737924,0,0,1.1737924,-37.836601,154.18926)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d6f0ff",
      fillOpacity: 0.58039216,
      stroke: "#c6d6ff",
      strokeWidth: 3.21992874,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 355.77734,67.044922 C 340.40221,67.432577 325.0612,82.929634 324.27148,109.99805 294.76735,108.9012 264.9589,105.32024 235.71484,98.234375 225.32708,213.37269 186.51885,345.68431 157.85742,412.51953 c 61.20948,-23.67655 274.28572,-4.99915 330,23.57227 -22.24686,-91.9446 -16.1902,-242.38068 7.85742,-342.142581 -33.065,6.494591 -78.96262,12.920791 -108.55273,14.937501 -2.46736,-29.236979 -16.94146,-42.205959 -31.38477,-41.841798 z m -0.26757,15.902344 c 5.12586,-2.95e-4 11.78132,5.763507 11.78125,11.551897 -8.9e-4,5.787627 -6.65606,9.407377 -11.78125,9.407087 -5.12443,-9.2e-4 -10.52841,-3.26318 -10.5293,-9.049945 -7e-5,-5.787529 5.4042,-11.908118 10.5293,-11.909039 z",
    transform: "scale(0.26458333)",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aa0000",
      stroke: "none",
      strokeWidth: "0.22540896px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 68.821902,34.808593 c -4.054934,2.498935 -16.43898,62.450111 -12.828936,65.213767 3.610044,2.76366 51.836554,7.12998 59.333834,4.00904 7.49728,-3.12094 13.08003,-65.769722 7.08264,-70.692789 -5.99739,-4.923067 -49.532604,-1.028953 -53.587538,1.469982 z",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: "0.22540896px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 63.405506,38.747766 c -2.040792,20.209964 -6.540378,33.043548 -9.921875,49.231398 22.976302,6.113258 46.569599,1.429088 70.020089,-0.755951 -0.26119,-17.284819 -0.82688,-34.434304 3.30729,-53.672618 -23.71116,7.045382 -47.55187,14.357944 -63.405504,5.197171 z",
    id: "path839"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 0.66161613,
      stroke: "none",
      strokeWidth: "0.22540896px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 66.015573,32.002264 c 8.031297,5.843801 -18.850292,45.144845 -6.013564,61.071084 6.551762,8.128622 44.173141,8.011372 44.173141,8.011372 -17.727307,0.65735 -33.604745,0.38976 -57.00208,3.88212 5.908979,-14.653295 12.561645,-48.642428 18.842503,-72.964576 z",
    id: "path830"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 1.056842,
    rx: 3.869405,
    cy: 91.060005,
    cx: 1.9892044,
    id: "ellipse834",
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 0.66161613,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.85193944,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    transform: "rotate(-72.221551)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-0.08183485,0.9966459,-0.8914928,-0.45303486,0,0)",
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 0.66161613,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.8855285,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    d: "m -24.2492,-106.74133 c -0.776921,0.8285 -0.439189,3.40161 -1.178769,3.40161 -0.739581,0 -1.499491,-2.49536 -1.499493,-3.40161 -3e-6,-0.90625 0.599547,-1.64092 1.339131,-1.64092 0.468349,0 3.055557,0.38645 3.294899,0.83268 0.13861,0.25843 -1.493011,0.31476 -1.955768,0.80824 z",
    id: "ellipse836"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d6f0ff",
      fillOpacity: 0.58039216,
      stroke: "#c6d6ff",
      strokeWidth: 0.51116365,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 71.803382,102.99909 -2.372016,8.61944 6.147199,0.70158 1.503389,-8.92012",
    id: "path841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path843",
    d: "m 86.497207,104.46375 -1.899546,9.70612 9.218256,1.64652 1.172659,-11.23522",
    style: {
      fill: "#d6f0ff",
      fillOpacity: 0.58039216,
      stroke: "#c6d6ff",
      strokeWidth: 0.51116365,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "4.87195063px",
      lineHeight: 1.25,
      fontFamily: "'Guttman Mantova'",
      InkscapeFontSpecification: "'Guttman Mantova'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#800000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.51116365,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    x: 92.179337,
    y: 64.061226,
    id: "text897",
    transform: "skewY(-7.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 92.179337,
    y: 64.061226,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "6.69893265px",
      fontFamily: "'Lucida Calligraphy'",
      InkscapeFontSpecification: "'Lucida Calligraphy'",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#800000",
      stroke: "#800000",
      strokeWidth: 0.51116365,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "tspan907"
  }, "I Can't Believe"), /*#__PURE__*/React.createElement("tspan", {
    x: 92.179337,
    y: 72.434891,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "6.69893265px",
      fontFamily: "'Lucida Calligraphy'",
      InkscapeFontSpecification: "'Lucida Calligraphy'",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#800000",
      stroke: "#800000",
      strokeWidth: 0.51116365,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "tspan913"
  }, "It's Not")), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.85193944
    },
    id: "g4734"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 60.994524,72.867568 c -0.47237,-0.790121 -0.64348,-2.185657 -0.22234,-2.974745 1.84147,-2.893528 9.84951,-3.788915 13.11012,-2.950079 0.22144,0.02363 0.42492,0.109201 0.64209,0.15472 0.24622,0.09227 0.4952,0.156006 0.74039,0.248997 0.23092,0.128894 0.46001,0.247457 0.6707,0.408276 0.16162,0.144653 0.327,0.278193 0.49646,0.409755 0.21798,0.187558 0.38027,0.418994 0.5316,0.660603 0.0872,0.195901 0.2072,0.352433 0.31225,0.537247 0.15635,0.306356 0.19064,0.645356 0.20756,0.983102 0.01,0.299212 10e-4,0.598157 0.0193,0.896983 -0.0424,0.249065 -0.043,0.515559 -0.14492,0.74953 -0.12171,0.268353 -0.18324,0.566063 -0.31784,0.827815 -0.14702,0.175993 -0.18085,0.4142 -0.32511,0.589164 -0.0526,0.133633 -0.10584,0.271647 -0.17263,0.399332 -0.0803,0.153578 -0.0366,-0.0404 -0.14689,0.219012 0.0171,0.07172 -0.063,0.03611 -0.0794,0.06648 -0.0257,0.04752 -0.0328,0.103277 -0.0557,0.152225 -0.0569,0.121751 -0.14657,0.244523 -0.2081,0.36517 -0.1723,0.171352 -0.31259,0.358127 -0.43281,0.568545 -2.20381,1.930164 -0.25398,0.289983 -0.18238,0.22515 0.009,-0.0077 -0.0211,-0.02453 -0.0299,-0.01714 -0.0334,0.02804 -0.046,0.07493 -0.0763,0.106251 -0.0102,0.01048 -0.0274,0.01 -0.0411,0.015 -0.0273,0.04278 -0.0546,0.08555 -0.082,0.128328 -0.032,0.03318 -0.061,0.06961 -0.0961,0.09952 -0.28217,0.240543 -0.58231,0.460293 -0.85515,0.711367 -0.20925,0.192553 0.44609,-0.352894 0.66406,-0.535522 0.0249,-0.02085 -0.0568,0.03158 -0.0839,0.04942 -0.12796,0.08417 -0.10225,0.07406 -0.22265,0.203298 -0.27255,0.22234 -0.53843,0.453115 -0.81766,0.667015 -0.0511,0.03917 -0.11869,0.05244 -0.17084,0.09023 -0.0285,0.02061 -0.0941,0.103574 -0.0665,0.08178 0.22662,-0.179207 0.43822,-0.376914 0.66542,-0.555384 0.0334,-0.02622 -0.0504,0.06915 -0.0822,0.09726 -0.27528,0.243372 -0.55862,0.477478 -0.83793,0.716217 -0.0804,0.07454 -0.19595,0.07976 -0.28543,0.135241 -0.0219,0.01357 -0.0296,0.04217 -0.0444,0.06326 -0.0415,0.02249 -0.0811,0.04887 -0.12445,0.06743 -0.0547,0.02344 -0.11709,0.02877 -0.16888,0.05813 -0.0185,0.0105 -0.021,0.037 -0.0315,0.0555 -0.0385,0.01852 -0.085,0.02564 -0.11553,0.05559 -0.0123,0.01204 0.0181,0.0381 0.007,0.05111 -0.0599,0.06931 -0.19975,0.0766 -0.26677,0.115546 -0.0146,0.0085 -0.01,0.03229 -0.0148,0.04843 -0.0382,0.01789 -0.0763,0.03579 -0.11444,0.05368 -0.0549,0.01521 -0.11416,0.01942 -0.16474,0.04568 -0.0143,0.0074 -2.6e-4,0.03672 -0.013,0.04662 -0.0991,0.07694 -0.15317,0.0298 -0.26798,0.08933 -0.014,0.0072 -0.006,0.03087 -0.01,0.04631 -0.0351,0.01556 -0.0703,0.03114 -0.1054,0.0467 0.007,0.01527 0.03,0.03265 0.0198,0.04578 -0.10549,0.135768 -0.44436,0.09352 -0.52071,0.251002 -0.0753,0.07179 -0.18699,0.061 -0.27174,0.109533 -0.0172,0.0098 -0.0412,0.06526 -0.0248,0.05403 0.26108,-0.179506 0.50793,-0.37896 0.7656,-0.563329 0.0273,-0.01953 -0.0446,0.05197 -0.0739,0.06842 -0.009,0.005 0.004,-0.02016 0.006,-0.03025 0.0797,-0.350618 0.12667,-0.379971 -0.095,-0.824357 -0.17126,-0.343348 -0.19102,-0.201372 -0.35763,-0.322064 -0.005,-0.0037 0.0208,0.0052 0.0188,-7.94e-4 -0.005,-0.01466 -0.0206,-0.0231 -0.0308,-0.03465 0.25438,-0.05306 0.51715,-0.0613 0.77631,-0.07148 0.15079,-0.164015 0.46144,-0.135501 0.66919,-0.143049 0.27913,-0.0049 0.55832,-5.3e-4 0.83747,0.0016 0.26595,0.0019 0.5319,0.0021 0.79785,0.0024 0.37753,-0.01746 0.7143,0.129321 1.01898,0.336553 0.26919,0.197429 0.35831,0.503722 0.51428,0.776377 0.15361,0.275834 0.21389,0.582039 0.24704,0.892146 0.0223,0.280228 0.021,0.561602 0.0212,0.84251 -7.9e-4,0.290918 -0.007,0.581393 0.0118,0.871789 -0.0302,0.288317 -0.0759,0.570995 -0.1698,0.845786 -0.12751,0.258299 -0.23062,0.518406 -0.43093,0.730565 -0.0273,0.05017 -0.0515,0.102221 -0.082,0.150495 -0.025,0.03946 -0.074,0.06 -0.0981,0.100004 -0.0803,0.133324 -0.10766,0.281657 -0.21955,0.396891 -0.055,0.07641 -0.17023,0.215141 -0.24113,0.280906 -0.0107,0.0099 -0.0298,0.0024 -0.0429,0.0087 -0.0926,0.04538 -0.1068,0.09099 -0.17831,0.18038 -0.0367,0.0313 -0.0722,0.06411 -0.11014,0.09391 -0.28922,0.224626 -0.57845,0.44925 -0.86767,0.673873 -0.0178,0.02357 -0.0304,0.05215 -0.0534,0.07069 -0.11348,0.09153 -0.26568,0.08727 -0.34866,0.207229 -0.0407,0.02032 -0.0889,0.0299 -0.12221,0.06098 -0.0131,0.01222 0.0115,0.04054 -5.3e-4,0.05372 -0.0991,0.107664 -0.3828,0.194286 -0.51236,0.233302 -0.0673,0.12424 -0.21733,0.100494 -0.32502,0.157972 -0.0167,0.0089 -0.008,0.0403 -0.0226,0.05194 -0.0507,0.03968 -0.11651,0.05645 -0.16845,0.09448 -0.0909,0.06319 -0.20916,0.05125 -0.30514,0.0982 -0.0202,0.0099 -0.0203,0.04241 -0.0386,0.05549 -0.12157,0.08666 -0.29949,0.102291 -0.44058,0.127087 -0.10815,0.07684 -0.25791,0.05014 -0.37295,0.09991 -0.0204,0.0088 -0.0201,0.04161 -0.0382,0.05456 -0.0608,0.04372 -0.17867,0.06644 -0.2442,0.08376 -0.004,0.01754 1.3e-4,0.04045 -0.0132,0.05264 -0.0669,0.061 -0.5102,0.179218 -0.60712,0.200546 -0.15866,0.06165 -0.348,0.0084 -0.5074,0.05293 -0.0206,0.0057 -0.024,0.03695 -0.0422,0.0483 -0.056,0.03509 -0.15749,0.04863 -0.21644,0.06069 -0.13697,0.05252 -0.30541,-0.0087 -0.4417,0.03191 -0.0169,0.0051 -0.0105,0.03629 -0.0246,0.04695 -0.0437,0.03309 -0.15758,0.04769 -0.20077,0.0562 -0.0469,0.0053 -0.0948,0.0046 -0.14055,0.01588 -0.0205,0.005 -0.0365,0.02133 -0.0547,0.032 -0.039,0.01016 -0.0777,0.02185 -0.1171,0.03047 -0.15386,0.03359 -0.30952,0.04852 -0.46603,0.06266 -0.1029,0.02257 -0.21024,-0.0029 -0.31341,0.01421 -0.0247,0.0041 -0.0442,0.02405 -0.0681,0.03176 -0.12977,0.04205 -0.27132,0.05352 -0.40573,0.07038 -0.0516,0.0046 -0.10572,-0.0028 -0.15483,0.01368 -0.0206,0.0069 -0.0265,0.03451 -0.0398,0.05177 -0.0293,0.01259 -0.0574,0.02829 -0.0878,0.03776 -0.13479,0.04192 -0.27904,0.04838 -0.41857,0.05904 -0.007,0.01593 -0.0141,0.03186 -0.0212,0.04779 -0.0279,0.01151 -0.0683,0.0086 -0.0838,0.03453 -0.0104,0.01725 0.0405,0.03238 0.0325,0.05088 -0.0376,0.08753 -0.31045,0.104643 -0.37791,0.116747 -0.0486,0.141965 0.0469,-0.09936 -0.11585,0.08638 -0.0115,0.01312 0.0336,0.0323 0.0237,0.04667 -0.0669,0.09718 -0.23239,0.01585 -0.2517,0.145555 0.7926,-0.619312 0.99185,-0.829164 0.69243,-0.523626 l -1.93173,-0.743818 v 0 c 0.36328,-0.297021 0.043,-0.03533 0.96515,-0.779973 0.26676,-0.09601 0.0942,-0.08169 0.25051,-0.145539 0.13847,-0.05656 0.28887,-0.09741 0.43312,-0.134488 0.16258,-0.19232 0.45906,-0.174604 0.68897,-0.202097 0.12911,-0.04039 0.25665,-0.09409 0.39285,-0.10615 0.0643,-0.0057 0.1292,2.25e-4 0.19351,-0.0051 0.0372,-0.003 0.0734,-0.01326 0.11014,-0.01987 0.26318,-0.05399 0.52654,-0.08329 0.79134,-0.124098 0.22284,-0.06038 0.43738,-0.149026 0.66369,-0.194693 0.22103,-0.06861 0.45262,-0.03105 0.66648,-0.128551 0.21548,-0.06513 0.44739,-0.02739 0.64372,-0.151024 0.191,-0.117552 0.39063,-0.228092 0.6119,-0.269507 0.12559,-0.06347 0.22924,-0.07262 0.36606,-0.108537 0.11482,-0.03014 0.21378,-0.120084 0.33619,-0.129839 0.15609,-0.130075 0.31795,-0.138552 0.45991,-0.274929 0.0695,-0.03575 0.13315,-0.08339 0.20581,-0.112075 0.0517,-0.0204 0.10886,-0.02548 0.15972,-0.04794 0.0881,-0.03891 0.13912,-0.1647 0.26392,-0.143494 0.10947,-0.17413 0.2795,-0.242657 0.448,-0.343694 0.0469,-0.01979 0.0975,-0.03249 0.14076,-0.05939 0.038,-0.02363 0.05,-0.07682 0.0867,-0.102441 0.0433,-0.03027 0.17697,-0.114306 0.13685,-0.07994 -0.1907,0.163356 -0.93544,0.758812 -0.58998,0.468381 0.11891,-0.02918 0.12858,-0.165653 0.21479,-0.244707 0.0126,-0.01159 0.0381,0.0065 0.0512,-0.0046 0.13592,-0.115496 0.0267,-0.127063 0.13416,-0.100428 0.18891,-0.216222 0.0686,0.09246 0.17608,-0.07887 0.0732,-0.116694 0.0811,-0.275013 0.22303,-0.338476 0.0515,-0.09611 0.13124,-0.263953 0.2206,-0.336822 0.0147,-0.01201 0.0417,0.007 0.0568,-0.0045 0.0358,-0.02726 0.0791,-0.163097 0.0888,-0.188658 0.0575,-0.04825 0.0292,-0.01574 0.0709,-0.108077 0.0103,-0.01074 0.0383,0.0089 0.0445,-0.0046 0.0412,-0.09117 -0.002,-0.222287 0.0701,-0.306703 0.015,-0.0085 0.0404,-0.0089 0.0451,-0.02548 0.0122,-0.04255 1.4e-4,-0.08852 2.2e-4,-0.132784 2.6e-4,-0.176268 7.9e-4,-0.352533 0.001,-0.528801 1.4e-4,-0.237861 10e-4,-0.475899 -0.0102,-0.713547 -0.008,-0.128911 -0.007,-0.260453 -0.0728,-0.375529 -0.0339,-0.06747 -0.064,-0.158533 -0.10228,-0.227327 -0.12458,-0.224065 -0.0299,-0.04347 0.0441,-0.01143 0.009,0.0056 0.0386,0.01966 0.0281,0.01678 -0.0705,-0.01929 -0.096,-0.03323 -0.25416,-0.02424 -0.26328,-2.65e-4 -0.52657,-0.0013 -0.78983,0.0016 -0.23464,0.0042 -0.47079,0.0076 -0.70236,0.04975 -0.23709,0.05187 -0.46458,0.145325 -0.71336,0.108699 -0.25893,0.02911 -0.51149,0.09082 -0.77019,0.120192 -0.19745,-0.0131 -0.48294,-0.0041 -0.65791,-0.119972 -0.48053,-0.318307 -0.68391,-0.745168 -0.48058,-1.306682 0.28141,-0.384154 0.69878,-0.621594 1.09491,-0.89761 0.0455,-0.03169 0.10766,-0.029 0.15764,-0.05297 0.0471,-0.0226 0.0554,-0.100997 0.124,-0.09578 0.117,-0.04291 0.23725,-0.09311 0.33232,-0.178186 0.0102,-0.0091 0.003,-0.02872 0.0111,-0.03953 0.0562,-0.07224 0.15321,-0.0855 0.23264,-0.115011 0.19389,-0.129083 -0.124,0.07332 0.2266,-0.09378 0.0364,-0.01733 0.018,-0.09971 0.0867,-0.0843 0.17525,-0.07943 0.13059,0.0042 0.1683,-0.09069 0.14841,-0.133623 -0.10271,0.08177 0.19681,-0.104188 0.032,-0.0199 -0.0261,-0.113469 0.0691,-0.08957 0.31387,-0.162967 0.0627,0.0074 0.23159,-0.112363 0.23601,-0.08684 0.089,-0.06036 0.24594,-0.150606 0.12359,-0.07109 0.17189,-0.08451 0.25754,-0.193903 -0.2206,0.19345 -0.44316,0.384683 -0.6618,0.580345 -0.0268,0.024 0.0588,-0.04167 0.0861,-0.06513 0.28183,-0.242295 0.5543,-0.49558 0.84109,-0.731978 0.0428,-0.03524 0.10029,-0.04848 0.14518,-0.08097 0.18371,-0.132974 0.50713,-1.147037 -0.53528,0.419941 0.12808,-0.06314 0.15648,-0.174548 0.26095,-0.264043 2.72585,-2.3353 -0.42028,0.432631 0.20765,-0.144984 0.11256,-0.02008 0.001,0.01254 0.12804,-0.143785 0.0141,-0.01741 0.0441,-0.0164 0.058,-0.03406 0.0401,-0.05122 0.0525,-0.123126 0.0999,-0.167624 0.0343,-0.03218 1.94094,-1.665245 0.13405,-0.04421 0.12714,-0.03888 0.005,0.01304 0.13981,-0.14398 0.017,-0.01977 0.0501,-0.02164 0.0657,-0.04263 0.078,-0.105519 0.1166,-0.247425 0.21492,-0.34168 0.0151,0.005 0.0314,0.02273 0.0453,0.015 0.0257,-0.01434 0.0904,-0.171905 0.0911,-0.172807 0.009,-0.01198 0.0361,-7.4e-5 0.043,-0.01339 0.046,-0.0881 0.0368,-0.199519 0.10567,-0.278794 0.1201,-0.03937 0.0733,-0.198265 0.1665,-0.277701 0.0121,-0.01034 0.0358,0.01939 0.0472,0.0082 0.20366,-0.201448 -0.0468,-0.05631 0.10998,-0.138985 0.0297,-0.0806 0.0645,-0.201385 0.12291,-0.27218 0.0149,-0.01812 0.0473,-0.01736 0.0599,-0.0372 0.0726,-0.114501 0.0978,-0.271886 0.17011,-0.387718 0.0208,-0.03187 0.0415,-0.06375 0.0623,-0.09562 0.0187,-0.0024 0.0424,0.0058 0.056,-0.0073 0.10513,-0.101002 0.0351,-0.310353 0.14355,-0.414231 0.007,-0.02964 0.0318,-0.170069 0.0656,-0.205418 0.0104,-0.0108 0.0384,0.0085 0.0446,-0.0052 0.0413,-0.09147 -0.002,-0.222742 0.0708,-0.307369 0.0151,-0.0083 0.0404,-0.0084 0.0452,-0.0249 0.0392,-0.134411 -0.0263,-0.469887 -0.003,-0.625118 -0.004,-0.126572 -0.0153,-0.253558 -0.016,-0.379773 -0.0442,-0.169431 -0.2381,-0.291266 -0.26971,-0.469876 -0.0604,-0.110961 -0.12014,-0.210182 -0.18415,-0.283284 -0.15958,-0.134035 -0.31751,-0.267052 -0.49346,-0.378063 -0.0995,-0.06062 -0.26635,-0.150831 -0.32901,-0.189029 -0.17656,-0.07149 -0.36065,-0.121748 -0.53615,-0.196426 -0.25838,-0.06415 -0.52377,-0.09154 -0.77302,-0.191212 -0.20522,-0.07509 -0.42079,-0.132649 -0.63704,-0.161176 -7.11331,-2.661983 -11.19982,4.383024 -11.30079,4.295685 z",
    id: "path4658",
    style: {
      opacity: 1,
      fill: "#800000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#800000",
      strokeWidth: 1.0223273,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 70.628124,72.396601 c -0.0191,0.250801 -0.0194,0.502528 -0.0204,0.753906 -2.6e-4,0.291894 10e-4,0.583761 -0.002,0.875636 -0.0354,0.282245 -0.10715,0.551244 -0.12534,0.836163 -0.0113,0.267383 -0.008,0.535101 -0.007,0.80264 0.0254,0.316921 0.006,0.616217 -0.0572,0.926552 -0.0939,0.222835 -0.15557,0.436409 -0.1682,0.677842 -0.0562,0.225853 -0.12019,0.433927 -0.12951,0.667885 -0.0548,0.220847 -0.11873,0.431175 -0.14747,0.657995 -0.0508,0.268258 -0.12825,0.52847 -0.20475,0.789985 -0.0316,0.254598 -0.11578,0.502684 -0.20081,0.744333 -0.0798,0.2452 -0.12084,0.50631 -0.23031,0.741654 -0.0821,0.09114 -0.0665,0.125505 -0.10525,0.259842 0.005,0.06276 -0.0555,0.09386 -0.0729,0.145103 -0.0195,0.05711 -0.0293,0.117041 -0.0439,0.175561 0.014,0.06986 -0.0934,0.113263 -0.11142,0.167606 -0.0182,0.0549 -0.0202,0.114096 -0.0361,0.169682 -0.0273,0.0952 -0.0674,0.186354 -0.0959,0.281176 -0.0162,0.0263 -0.0293,0.05475 -0.0486,0.07887 -0.0181,0.02257 -0.0598,0.02297 -0.0711,0.04955 -0.0486,0.114131 -0.0441,0.187939 -0.11899,0.28375 -0.0154,0.05686 -0.0309,0.113721 -0.0464,0.17058 -3.17587,-0.168293 -1.61824,-0.790841 -0.96207,-2.71724 0.0383,-0.146957 0.0257,-0.332576 0.15697,-0.435387 0.0463,-0.263618 0.1347,-0.507043 0.18741,-0.767334 0.36977,-1.758608 1.19987,-5.724736 0.74321,-7.327783 2.54851,-0.545992 2.2048,-1.028299 1.91803,0.991433 z",
    id: "path4666",
    style: {
      opacity: 1,
      fill: "#800000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#800000",
      strokeWidth: 1.0223273,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 83.439604,65.706575 c 1.694,0.137372 2.82957,0.507466 2.12472,2.364554 -1.08429,3.15818 -2.07017,5.250463 -2.80082,8.278652 -0.55685,2.350802 0.0232,3.523249 1.16983,4.332975 1.48567,1.049188 3.33867,1.365901 -1.14303,1.569264 -2.87167,-0.471897 -2.36901,-3.731649 -2.01837,-5.835202 0.0174,-0.06973 0.0485,-0.135824 0.0627,-0.206272 0.36812,-3.507204 4.33472,-9.216652 2.04623,-8.419203 l 0.55858,-2.084644 z",
    id: "path4668",
    style: {
      opacity: 1,
      fill: "#800000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#800000",
      strokeWidth: 1.0223273,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 88.768604,76.862543 c -1.05842,2.138293 0.30305,3.089515 2.13302,3.59577 2.09258,-0.185884 2.62834,-1.002947 2.75316,-2.756823 0.0402,-0.168429 -0.0269,-0.326388 -0.0343,-0.490713 -1.39109,-3.591547 -1.49039,-1.266158 -0.13175,-2.161454 -0.0555,-0.64527 -0.0648,-0.406333 0.54906,-0.02563 0.11215,0.04269 0.2054,0.177178 0.33272,0.162875 0.21565,0.09269 0.43661,0.190727 0.66508,0.249097 0.21601,0.0091 0.42168,0.04401 0.63127,0.09855 0.64446,-0.110022 1.47479,-0.71871 2.13168,-0.54634 1.02848,0.269888 1.49602,1.504097 -0.88163,2.278327 v 0 c -0.19432,0.08582 -0.1187,0.03855 -0.23715,0.12383 -0.1027,0.03288 -0.29462,0.130381 -0.40219,0.14283 -0.21269,0.02461 -0.4151,-0.01701 -0.62617,-0.02246 -0.28271,-0.01714 -0.56477,-0.04737 -0.83833,-0.124667 -0.24726,-0.05664 -0.50731,-0.05879 -0.74365,-0.163052 -0.6499,-0.237877 -0.78101,-0.736106 -1.36107,-1.339701 -2.65128,-2.021886 -0.45255,-2.747051 1.50262,-1.364645 0.17236,0.122743 0.32999,0.260292 0.47536,0.413957 0.23443,0.229301 0.45513,0.477811 0.55587,0.797697 0.0405,0.224809 0.16302,0.426742 0.22136,0.647079 0.1149,0.298553 0.16848,0.612814 0.15364,0.933976 0.002,0.291272 0.007,0.583348 -0.0194,0.873758 -0.0136,0.1037 -0.0139,0.265887 -0.0794,0.3562 -0.009,0.01302 -0.0383,0.0061 -0.0432,0.02143 -0.0308,0.09555 0.008,0.204886 -0.0335,0.299334 -0.0137,0.06098 -0.0301,0.164462 -0.0656,0.222605 -0.0109,0.01794 -0.0403,0.02257 -0.0464,0.04269 -0.0469,0.1549 -0.009,0.33813 -0.0734,0.491355 -0.0199,0.07465 -0.0502,0.146299 -0.0699,0.220983 -0.0461,0.173858 -0.0523,0.387493 -0.20171,0.510667 -0.71253,1.064696 -0.60088,2.368373 -3.43453,2.187116 -1.59247,-0.140424 -3.12841,-0.62395 -4.29047,-1.698016 -1.02487,-1.323882 -1.00994,-3.504392 -0.22358,-4.822637 0.0312,-0.06276 0.0574,-0.128278 0.0937,-0.18827 1.176,-1.017617 1.92266,-2.027477 4.05073,-2.18072 1.81471,1.587422 -2.02925,1.413847 -2.41194,3.215002 z",
    id: "path4674",
    style: {
      opacity: 1,
      fill: "#800000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#800000",
      strokeWidth: 1.0223273,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 113.27215,77.396532 c -0.28459,0.01204 -0.56681,-0.01863 -0.8511,-0.01916 -1.41095,0.70845 -2.06923,0.765372 -2.5311,1.870331 -0.0959,0.177826 -0.13385,0.371599 -0.156,0.570037 -0.0204,0.249155 -0.0186,0.499438 -0.0187,0.749226 0.0351,0.142295 -0.003,0.03947 0.0843,0.164946 0.10808,0.09634 0.0545,0.06984 0.17323,0.129127 0.71941,0.2141 1.48094,0.287432 2.20136,0.297994 0.19974,-0.0013 0.41582,0.03519 0.57646,-0.102201 0.0777,-0.05422 0.18179,-0.03746 0.26271,-0.08031 0.0834,-0.04415 0.006,-0.06657 0.0629,-0.118239 0.14214,-0.129987 0.0928,0.0075 0.12506,-0.129342 -0.0969,0.12537 0.42693,-0.337129 0.27126,-0.205007 -1.05838,0.898284 -0.66978,0.549955 -0.39172,0.362662 0.0487,-0.05604 0.0974,-0.112091 0.14605,-0.168138 0.0307,-0.01765 0.0658,-0.02933 0.0922,-0.05297 0.042,-0.03759 0.0721,-0.08669 0.11021,-0.128222 0.10564,-0.11516 0.22192,-0.217702 0.32874,-0.332086 1.17199,-1.299173 2.18172,-2.745893 2.83355,-4.285719 0.2307,-0.488616 0.41904,-0.990658 0.61293,-1.494464 6.47661,-13.49874 -4.40082,4.366709 -1.76441,7.68751 2.89483,0.847483 4.23588,-0.58499 5.22239,-2.70743 v 0 c 0.43221,0.228171 0.24422,0.08863 0.57187,0.407767 0.0552,0.09982 0.124,0.193239 0.16551,0.299474 0.42334,3.110259 -3.82726,4.746839 -6.33437,3.896838 -0.3589,-0.06924 -0.70756,-0.179657 -1.00016,-0.406855 -0.27182,-0.243485 -0.48629,-0.513929 -0.60687,-0.864409 -0.12332,-0.309364 -0.1569,-0.624068 -0.13775,-0.956228 -8e-4,-0.270143 -0.002,-0.540322 0.003,-0.810435 0.01,-0.357008 0.0331,-0.714354 0.11011,-1.064186 0.21976,-1.200233 0.76495,-2.236734 1.18743,-3.293586 0.0362,-0.09224 0.0566,-0.190487 0.097,-0.280951 0.0694,-0.155387 0.19657,-0.281828 0.23388,-0.453821 0.16603,-0.349549 0.0867,-0.165653 0.23503,-0.55296 0.0394,-0.08337 0.0974,-0.156882 0.13998,-0.23867 1.14374,-2.874788 2.77974,-5.139073 3.64694,-7.460284 0.16849,-0.461682 0.18491,-0.566248 0.93272,-0.9798 2.88054,0.165667 -3.06205,9.843435 -3.97172,11.514106 -0.87889,1.442172 -1.01605,2.019933 -0.77407,3.115034 -0.049,0.05635 -0.0771,0.129641 -0.13003,0.182312 -0.0232,0.02312 -0.0605,0.02506 -0.0908,0.0376 -0.37141,0.492329 -0.87633,0.85716 -1.37155,1.218673 -0.0981,0.04209 -0.1903,0.09713 -0.28851,0.138944 -0.21196,0.09024 -0.44212,0.104444 -0.65742,0.184726 -0.33444,0.05171 -0.66697,0.06103 -1.00502,0.0403 -0.29335,-0.01384 -0.58654,-0.03847 -0.87382,-0.102722 -0.27372,-0.0567 -0.54699,-0.05552 -0.82124,-0.10968 -1.70404,-1.438094 -1.72,-3.777397 -0.43041,-5.096041 1.39623,-1.427689 3.05468,-2.284935 5.10815,-2.297465 0.24185,-0.0039 0.49371,0.0024 0.72383,-0.08138 -0.68005,2.662356 -0.0292,1.996818 -2.05203,2.005154 z",
    id: "path4706",
    style: {
      opacity: 1,
      fill: "#800000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#800000",
      strokeWidth: 1.0223273,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#800000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#800000",
      strokeWidth: 1.0223273,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    id: "path4726",
    d: "m 100.26997,77.450756 c -1.058416,2.138293 0.30305,3.089515 2.13302,3.59577 2.09258,-0.185884 2.62834,-1.002947 2.75316,-2.756823 0.0402,-0.168429 -0.0269,-0.326388 -0.0343,-0.490713 -1.39109,-3.591547 -1.49039,-1.266158 -0.13175,-2.161454 -0.0555,-0.64527 -0.0648,-0.406333 0.54906,-0.02563 0.11215,0.04269 0.2054,0.177178 0.33272,0.162875 0.21565,0.09269 0.43661,0.190727 0.66508,0.249097 0.21601,0.0091 0.42168,0.04401 0.63127,0.09855 0.64446,-0.110022 1.47479,-0.71871 2.13168,-0.54634 1.02848,0.269888 1.49602,1.504097 -0.88163,2.278327 v 0 c -0.19432,0.08582 -0.1187,0.03855 -0.23715,0.12383 -0.1027,0.03288 -0.29462,0.130381 -0.40219,0.14283 -0.21269,0.02461 -0.4151,-0.01701 -0.62617,-0.02246 -0.28271,-0.01714 -0.56477,-0.04737 -0.83833,-0.124667 -0.24726,-0.05664 -0.50731,-0.05879 -0.74365,-0.163052 -0.6499,-0.237877 -0.78101,-0.736106 -1.36107,-1.339701 -2.65128,-2.021886 -0.45255,-2.747051 1.50262,-1.364645 0.17236,0.122743 0.32999,0.260292 0.47536,0.413957 0.23443,0.229301 0.45513,0.477811 0.55587,0.797697 0.0405,0.224809 0.16302,0.426742 0.22136,0.647079 0.1149,0.298553 0.16848,0.612814 0.15364,0.933976 0.002,0.291272 0.007,0.583348 -0.0194,0.873758 -0.0136,0.1037 -0.0139,0.265887 -0.0794,0.3562 -0.009,0.01302 -0.0383,0.0061 -0.0432,0.02143 -0.0308,0.09555 0.008,0.204886 -0.0335,0.299334 -0.0137,0.06098 -0.0301,0.164462 -0.0656,0.222605 -0.0109,0.01794 -0.0403,0.02257 -0.0464,0.04269 -0.0469,0.1549 -0.009,0.33813 -0.0734,0.491355 -0.0199,0.07465 -0.0502,0.146299 -0.0699,0.220983 -0.0461,0.173858 -0.0523,0.387493 -0.20171,0.510667 -0.71253,1.064696 -0.60088,2.368373 -3.43453,2.187116 -1.59247,-0.140424 -3.128406,-0.62395 -4.290466,-1.698016 -1.02487,-1.323882 -1.00994,-3.504392 -0.22358,-4.822637 0.0312,-0.06276 0.0574,-0.128278 0.0937,-0.18827 1.176,-1.017617 1.922656,-2.027477 4.050726,-2.18072 1.81471,1.587422 -2.02925,1.413847 -2.41194,3.215002 z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.85193944
    },
    id: "g4806"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.97046527,0.24124088,-0.80163308,0.59781637,0,0)",
    ry: 1.6732917,
    rx: 5.6658487,
    cy: 61.690296,
    cx: 126.91927,
    id: "path4764",
    style: {
      opacity: 0.4,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.16237628,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.4,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.16237628,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    id: "ellipse4766",
    cx: 138.21593,
    cy: 55.645153,
    rx: 5.6658487,
    ry: 1.6732917,
    transform: "matrix(0.97046527,0.24124088,-0.80163308,0.59781637,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.88215016,0.47096826,-0.52960369,0.84824521,0,0)",
    ry: 0.98389375,
    rx: 2.4213324,
    cy: 21.320471,
    cx: 119.21778,
    id: "ellipse4768",
    style: {
      opacity: 0.4,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.02350199,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.4,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.02350199,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    id: "ellipse4770",
    cx: 129.03944,
    cy: 16.749462,
    rx: 2.4213324,
    ry: 0.98389375,
    transform: "matrix(0.88215016,0.47096826,-0.52960369,0.84824521,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.78930008,0.61400765,-0.39386095,0.91917003,0,0)",
    ry: 0.79527932,
    rx: 1.6267401,
    cy: 0.71723861,
    cx: 128.90897,
    id: "ellipse4772",
    style: {
      opacity: 0.4,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.0394454,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.4,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.0394454,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    id: "ellipse4774",
    cx: 117.51882,
    cy: 7.6389313,
    rx: 1.6267401,
    ry: 0.79527932,
    transform: "matrix(0.78930008,0.61400765,-0.39386095,0.91917003,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.84421333,0.53600732,-0.46483464,0.88539751,0,0)",
    ry: 0.82561439,
    rx: 1.863465,
    cy: 23.004566,
    cx: 112.43494,
    id: "ellipse4776",
    style: {
      opacity: 0.4,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.02406001,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.4,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.02260864,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    id: "ellipse4778",
    cx: 88.190231,
    cy: -51.27943,
    rx: 2.5820515,
    ry: 1.2466861,
    transform: "matrix(0.23941154,0.97091818,-0.96244566,0.2714744,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.23941154,0.97091818,-0.96244566,0.2714744,0,0)",
    ry: 1.2466861,
    rx: 2.5820515,
    cy: -54.957905,
    cx: 96.610542,
    id: "ellipse4780",
    style: {
      opacity: 0.4,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.02260864,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.4,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.14060068,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    id: "ellipse4782",
    cx: 130.57321,
    cy: 14.014763,
    rx: 1.4815481,
    ry: 0.83202642,
    transform: "matrix(0.84661757,0.53220174,-0.93170203,0.36322352,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.84661757,0.53220174,-0.93170203,0.36322352,0,0)",
    ry: 0.83202642,
    rx: 1.4815481,
    cy: 6.9030232,
    cx: 136.73193,
    id: "ellipse4784",
    style: {
      opacity: 0.4,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.14060068,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.4,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.14060068,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    id: "ellipse4786",
    cx: 132.07352,
    cy: -9.3990669,
    rx: 1.4815481,
    ry: 0.83202642,
    transform: "matrix(0.84661757,0.53220174,-0.93170203,0.36322352,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.15046065,0.988616,-0.99223646,-0.12436565,0,0)",
    ry: 1.7886845,
    rx: 1.209466,
    cy: -106.97868,
    cx: 68.723869,
    id: "ellipse4788",
    style: {
      opacity: 0.4,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.04219937,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.4,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.04219937,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    id: "ellipse4790",
    cx: 66.773987,
    cy: -112.10745,
    rx: 1.209466,
    ry: 1.7886845,
    transform: "matrix(0.15046065,0.988616,-0.99223646,-0.12436565,0,0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404V1);
export default __webpack_public_path__ + "static/media/404_v1.4383a3d4fc694b169660674935b6d558.svg";
export { ForwardRef as ReactComponent };